export * from './shared-components.module';
export * from './confirmation-dialog/confirmation-dialog.component';
export * from './ngx-svg/ngx-svg.component';
